import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Row,
  Col,
  Divider,
} from 'antd';

import { Spinner } from '../../UI';
import {
  UserForm,
  ChangePassword,
  DeleteUser,
} from '../../Profile';

import styles from './Profile.module.css';

const { Title } = Typography;

class Profile extends Component {
  state = {
    profile: {}
  };

  componentDidMount () {
    this.props.fetchUserInfo(() => {
      this.props.fetchProfile();
      this.props.fetchTimeZone();
      this.props.fetchCountries();
    });
  };

  render() {
    const {
      pageLoading,
      loading,
      profile,
      timeZones,
      countries,
      fetchProfile,
      setProfile,
      changePassword,
      deleteProfile,
      err,
    } = this.props;

    let content = <Spinner />;
    if (!pageLoading && (!!this.props.profile.data && this.props.profile.data.length > 0)) {
      content = (
        <Row
          type="flex"
          gutter={15}
          className={styles.row}
        >
          <Col
            lg={12}
            sm={24}
            className={styles.col}
          >
            <UserForm
              profile={profile}
              loading={loading}
              timeZones={timeZones}
              countries={countries}
              fetchProfile={fetchProfile}
              setProfile={setProfile}
              err={err}
            />
          </Col>
          <Col
            lg={1}
            className={`${styles.col} ${styles['col--center']}`}
          >
            <Divider
              type="vertical"
              style={{ height: '100%' }}
            />
          </Col>
          <Col
            lg={11}
            sm={24}
            className={styles.col}
          >
            <ChangePassword
              changePassword={changePassword}
              loading={loading}
              err={err}
            />
            <Divider style={{ margin: '28px 0 20px' }} />
            <DeleteUser deleteProfile={deleteProfile} />
          </Col>
        </Row>
      );
    }

    return (
      <div>
        <Title>Profile</Title>
        <Divider/>
        {content}
      </div>
    );
  }
}

Profile.propTypes = {
  pageLoading: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  profile: PropTypes.object.isRequired,
  timeZones: PropTypes.array.isRequired,
  countries: PropTypes.array.isRequired,
  fetchProfile: PropTypes.func.isRequired,
  setProfile: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired,
  err: PropTypes.object.isRequired
};

export default Profile;
